import { Resource } from "../../types/resource";

export const wrapContentInResourceTags = (resource: Resource, currentChatId: string) => {
    let wrappedContent = '<resource>\n';
    wrappedContent += `<chatid>${currentChatId}</chatid>\n`;
    switch (resource.type) {
      case 'essay':
        wrappedContent += `<essay>\n<title>${resource.title}</title>\n<content>${resource.content}</content>\n</essay>`;
        break;
      case 'code':
        wrappedContent += `<code language="${resource.language}" title="${resource.title}">${resource.content}</code>`;
        break;
      case 'visualization':
        wrappedContent += `<visualization title="${resource.title}">${resource.content}</visualization>`;
        break;
      default:
        console.error('Unknown resource type:', resource.type);
        return null;
    }
    wrappedContent += '\n</resource>';
    return wrappedContent;
};